import React, { useLayoutEffect, useRef, useState } from 'react';

const PIXELS_PER_SECOND = 50;
const MIN_DURATION_SECONDS = 6;

// Renders the message centered/truncated when it fits, or as a continuously
// scrolling news-ticker when it's wider than the available space (e.g. long
// messages on narrow mobile screens).
const AlertBannerMessage = ({ message }) => {
  const containerRef = useRef(null);
  const textRef = useRef(null);
  const [marqueeDuration, setMarqueeDuration] = useState(null);

  useLayoutEffect(() => {
    const measure = () => {
      if (!containerRef.current || !textRef.current) return;
      const overflowing = textRef.current.scrollWidth > containerRef.current.clientWidth;
      if (!overflowing) {
        setMarqueeDuration(null);
        return;
      }
      setMarqueeDuration(Math.max(textRef.current.scrollWidth / PIXELS_PER_SECOND, MIN_DURATION_SECONDS));
    };
    measure();
    window.addEventListener('resize', measure);
    return () => window.removeEventListener('resize', measure);
  }, [message]);

  if (!marqueeDuration) {
    return (
      <div ref={containerRef} className="w-full overflow-hidden">
        <p ref={textRef} className="truncate text-center text-xs sm:text-sm font-medium text-white">
          {message}
        </p>
      </div>
    );
  }

  return (
    <div ref={containerRef} className="w-full overflow-hidden">
      <div className="flex w-max whitespace-nowrap animate-marquee" style={{ animationDuration: `${marqueeDuration}s` }}>
        <span ref={textRef} className="pr-12 text-xs sm:text-sm font-medium text-white">{message}</span>
        <span aria-hidden="true" className="pr-12 text-xs sm:text-sm font-medium text-white">{message}</span>
      </div>
    </div>
  );
};

export default AlertBannerMessage;
